import { Component, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { ISearchResponseRow, ISearchResultRenderer } from "../../quick-search.models";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { DatePipe } from "@angular/common";

@Component({
    selector: "rask-kund-lev-term-order-renderer",
    templateUrl: "./kund-lev-term-order-renderer.component.html",
    styleUrls: [
        "./kund-lev-term-order-renderer.component.scss",
        "../default-renderer.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgbPopover,
        DatePipe
    ]
})
export class KundLevTermOrderRendererComponent implements ISearchResultRenderer {
    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;
}
